
import { ProjectsUI } from '@droid/project-v2-ui';
import { Box } from '@mui/material';
import { OpenA11yNodeButton } from '@src/components/a11y/open-a11y-node-button';
import { AndroidFloatWindowLink } from '@src/components/android-float/window/AndroidFloatWindowLink';
import { KillSelf } from '@src/components/app/kill-self/KillSelf';
import { DocMainPage } from '@src/components/browser/DocMainPage';
import { NotificationListenerPanel } from '@src/components/notification-listener/NotificationListenerPanel';

export function HomeGlobalProdContent() {
  return (
    <Box>
      {/* <AndroidSettingsInfo /> */}
      {/* <HomePagePermissions /> */}
      <NotificationListenerPanel />
      <AndroidFloatWindowLink />
      <Box>
        <OpenA11yNodeButton />
      </Box>
      <DocMainPage />
      <Box>
        <KillSelf />
      </Box>
      
      <ProjectsUI/>
    </Box>
  );
}
